module.exports = __webpack_public_path__ + "static/media/62.829ccec2.png";